import { Box, List, Skeleton, Stack } from '@chakra-ui/react';

import CalendarSVG from '@housekeep/design-tokens/dist/assets/icons/calendar-blank.svg';
import ClockSVG from '@housekeep/design-tokens/dist/assets/icons/clock.svg';
import HouseSVG from '@housekeep/design-tokens/dist/assets/icons/house.svg';
import LocationPinSVG from '@housekeep/design-tokens/dist/assets/icons/location-pin.svg';
import MoneyNotesSVG from '@housekeep/design-tokens/dist/assets/icons/money-notes.svg';
import PhoneSVG from '@housekeep/design-tokens/dist/assets/icons/phone.svg';
import StarSVG from '@housekeep/design-tokens/dist/assets/icons/star.svg';
import TickSquareSVG from '@housekeep/design-tokens/dist/assets/icons/tick-square.svg';

import { DEFAULT_CAMPAIGN } from 'common/hooks/RecruitmentCampaign';

import ListItemWithIcon from 'common/components/ListItemWithIcon/ListItemWithIcon';

import { Campaign } from '../utils/api';

export default function CleanerBenefits({ campaign }: { campaign?: Campaign }) {
  return (
    <Stack direction={['column', null, 'row']} spacing={[2, null, 4]}>
      <Box w={['100%', null, '50%']}>
        <List spacing={2} fontSize="lg">
          <ListItemWithIcon icon={ClockSVG}>Work full-time or part-time</ListItemWithIcon>
          <ListItemWithIcon icon={CalendarSVG}>Choose your working days & hours</ListItemWithIcon>
          <ListItemWithIcon icon={LocationPinSVG}>Choose your working areas</ListItemWithIcon>
          {campaign ? (
            <ListItemWithIcon icon={MoneyNotesSVG}>
              {campaign?.payRateDescription ?? DEFAULT_CAMPAIGN.payRateDescription}
            </ListItemWithIcon>
          ) : (
            <ListItemWithIcon icon={MoneyNotesSVG}>
              <Skeleton height={3} />
            </ListItemWithIcon>
          )}
        </List>
      </Box>

      <Box w={['100%', null, '50%']}>
        <List spacing={2} fontSize="lg">
          <ListItemWithIcon icon={HouseSVG}>Regular local customers</ListItemWithIcon>
          <ListItemWithIcon icon={StarSVG}>Manage everything in your app</ListItemWithIcon>
          <ListItemWithIcon icon={PhoneSVG}>7-day cleaner support</ListItemWithIcon>
          <ListItemWithIcon icon={TickSquareSVG}>Start immediately</ListItemWithIcon>
        </List>
      </Box>
    </Stack>
  );
}
